import React from 'react';

const ICONS = {
  yt: (
    <svg viewBox="0 0 24 24" role="img" focusable="false"><polygon points="10,8 16,12 10,16" /></svg>
  ),
  ig: (
    <svg viewBox="0 0 24 24" role="img" focusable="false">
      <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5.2" fill="none" />
      <circle cx="12" cy="12" r="5.2" fill="none" />
      <circle cx="17.4" cy="6.6" r="1.6" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24" role="img" focusable="false">
      <path d="M5.5 4h2.9l4.6 5.4L17.8 4H21l-6.8 7.9L21.5 20h-2.9l-5-5.8L8.2 20H5l7.1-8.2L5.5 4z" />
    </svg>
  ),
  tt: (
    <svg viewBox="0 0 24 24" role="img" focusable="false">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
  ),
  fb: (
    <svg viewBox="0 0 24 24" role="img" focusable="false">
      <path d="M14 8h3V4h-3c-2.8 0-5 2.2-5 5v2H6v4h3v8h4v-8h3l1-4h-4V9c0-.6.4-1 1-1z" />
    </svg>
  ),
  dc: (
    <svg viewBox="0 0 24 24" role="img" focusable="false">
      <path d="M18.9 5.5c-1.4-1-3-1.6-4.7-1.6-1.7 0-3.3.6-4.7 1.6-2.8 2-4.5 5.4-4.5 9.1 0 2.7 1.2 5.2 3.2 6.8l.7-1.1c-1.5-1.1-2.4-2.8-2.4-4.7 0-3 1.5-5.7 3.9-7.3 1.1-.8 2.4-1.2 3.8-1.2s2.7.4 3.8 1.2c2.4 1.6 3.9 4.3 3.9 7.3 0 1.9-.9 3.6-2.4 4.7l.7 1.1c2-1.6 3.2-4.1 3.2-6.8 0-3.7-1.7-7.1-4.5-9.1zM9.5 12.5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm5 0c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" />
    </svg>
  ),
};

export function getSocialIcon(cls) {
  return ICONS[cls] || ICONS.x;
}

export function enrichSocialLinks(links) {
  return links.map((s) => ({
    ...s,
    href: s.url || s.href,
    icon: getSocialIcon(s.cls),
  }));
}
